import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../assets/images/collapsed_logo.svg";
import CareMatics from "../../assets/images/CareMatics_lg.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import leftArrow from "../../assets/images/left-arrow.png";
 import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem
} from "reactstrap";
import { Link, NavLink } from "react-router-dom";
import { clinicAdminMenu, patientMenu, superAdminMenu } from "./Constant";
import { platformLayout } from "../../utils/constants";
import { resetBreadcrumb } from "../../context/reducers/breadcrump";

const Sidebar = () => {
  let role = localStorage.getItem("userRole");
  let roleId = localStorage.getItem("roleId");
  const roles = useSelector((state) => state?.userReducer?.user?.roles);
  const defaultPermissions = useSelector((state) => state?.userReducer?.user?.defaultRole?.value?.permissions);
  const matchedRole = roles?.find((role) => role.value._id === roleId);
  const permissions = matchedRole?.permissions || defaultPermissions;
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleTabClick = (index) => {
    if (activeTab !== index) {
      setActiveTab(index);
      dispatch(resetBreadcrumb());
    }
  };

    // Set active tab based on current route
    useEffect(() => {
      const menu = role === platformLayout.Platform ? superAdminMenu(permissions) : role === platformLayout.Organization ? clinicAdminMenu(permissions) : patientMenu();
      let activeIndex;
    // Check specific routes and manually set activeIndex
    if(location.pathname === "/super-admin/orgViewDetail"){
      activeIndex = menu.findIndex(({ URL }) => URL === "/super-admin/organization");
    } else if(location.pathname === "/super-admin/user-details"){
      activeIndex = menu.findIndex(({ URL }) => URL === "/super-admin/users");
    } else if(location.pathname === "/app/application-detail"){
      activeIndex = menu.findIndex(({ URL }) => URL === "/app/admin-application");
    }else if(location.pathname === "/super-admin/clinicDetail"){
      activeIndex = menu.findIndex(({ URL }) => URL === "/super-admin/organization");
    }else if(location.pathname === "/clinic/patient-profile"){
      activeIndex = menu.findIndex(({ URL }) => URL === "/clinic/patient-list");
    }else if(location.pathname == "/app/start-application"){
      activeIndex = menu.findIndex(({ URL }) => URL === "/app/admin-application");
    }else if(location?.pathname === "/clinic/add-patient"){
      activeIndex = menu.findIndex(({ URL }) => URL === "/clinic/patient-list");
    }else if(location?.pathname === "/clinic/calendar"){
      activeIndex = menu.findIndex(({ URL }) => URL === "/app/actions");
    }else {
      activeIndex = menu.findIndex(({ URL }) => URL === location.pathname);
    }
      setActiveTab(activeIndex);
    }, [location.pathname, role, permissions]);

document.querySelectorAll('.sidebar.collapsed .nav-item a').forEach((item) => {
  item.addEventListener('mouseenter', (e) => {
    const tooltip = item.querySelector('.tooltip-text');
    if (!tooltip) return; // prevent error if tooltip not found

    const rect = item.getBoundingClientRect();
    tooltip.style.top = `${rect.top + rect.height / 2}px`;
    tooltip.style.display = 'block';
    tooltip.style.opacity = '1';
  });

  item.addEventListener('mouseleave', (e) => {
    const tooltip = item.querySelector('.tooltip-text');
    if (!tooltip) return;

    tooltip.style.opacity = '0';
    tooltip.style.display = 'none';
  });
});

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="logo_container">
        <Navbar>
          <div className="navbar-brand">
            <NavbarBrand>
              <div className="d-flex justify-content-between align-items-center logo-container gap-3">
                <div className="logo_sideb">
                  <img src={Logo} alt="Logo-img" />
                </div>
                <div className={`collapse_block ${isCollapsed ? "hide" : ""}`}>
                  <img src={CareMatics} alt="text_logo" />
                </div>
              </div>
            </NavbarBrand>
            <div onClick={toggle} className="toggle_img">
              <img src={leftArrow} alt="text_logo" />
            </div>
          </div>
          <div className="nav-container">
          <Nav navbar>
            {(role == platformLayout.Platform) &&
              superAdminMenu(permissions)?.map(
                ({ name, URL, icon, isHidden, readOnly }, index) => (
                  <div key={index}>
                        {!isHidden ? <NavItem key={index} className={activeTab === index ? 'active' : ''}>
                          <NavLink to={URL} onClick={()=> handleTabClick(index)} className="position-relative" >
                            <div className="d-flex gap-3 link align-items-center nav_space">
                              <div className="icon-wrap">
                                <img src={`/assets/icons/${icon}`} alt="icon" />
                              </div>
                          <h4 className={`collapse_block ${isCollapsed ? "hide" : ""}`}>{name}</h4>
                          {isCollapsed && <span className="tooltip-text">{name}</span>}
                            </div>
                          </NavLink>
                        </NavItem> : null}
                  </div>
                )
            )}
            {(role == platformLayout.Organization) &&
              clinicAdminMenu(permissions)?.map(
                ({ name, URL, icon, isHidden, readOnly }, index) => (
                  <div key={index}>
                        {!isHidden ? <NavItem key={index} className={activeTab === index ? 'active' : ''}>
                          <NavLink to={URL} onClick={()=> handleTabClick(index)} className="position-relative">
                            <div className="d-flex gap-3 link align-items-center nav_space">
                              <div className="icon-wrap">
                                <img src={`/assets/icons/${icon}`} alt="icon" />
                              </div>
                              <h4 className={`collapse_block ${isCollapsed ? "hide" : ""}`}>{name}</h4>
                              {isCollapsed && <span className="tooltip-text">{name}</span>}
                            </div>
                          </NavLink>
                        </NavItem> : null}
                  </div>
                )
            )}
            {role == platformLayout.Patient &&
              patientMenu()?.map(
                ({ name, URL, icon, isHidden, readOnly }, index) => (
                  <div key={index}>
                  {!isHidden ? <NavItem key={index} className={activeTab === index ? 'active' : ''}>
                    <NavLink to={URL} onClick={()=> handleTabClick(index)} className="position-relative">
                      <div className="d-flex gap-3 link align-items-center nav_space">
                        <div className="icon-wrap">
                          <img src={`/assets/icons/${icon}`} alt="icon" />
                        </div>
                        <h4 className={`collapse_block ${isCollapsed ? "hide" : ""}`}>{name}</h4>
                        {isCollapsed && <span className="tooltip-text">{name}</span>}
                      </div>
                    </NavLink>
                  </NavItem> : null}
                  </div>
                )
            )}
          </Nav>
          </div>
        </Navbar>
      </div>
    </div>
  );
};

export default Sidebar;
